<template>
  <v-container fluid>
    <Alert_salary_gov />
    <v-row no-gutters>
      <v-col cols="12" md="12">
        <!-- พนักงานราชการ - รายงานการสำรวจตำแหน่งว่าง -->
        <v-hover
          v-slot="{ hover }"
          v-if="period_teacher_govem_manpower.period_college_enable === '1'"
        >
          <v-card
            :elevation="hover ? 24 : 8"
            :class="{ 'on-hover': hover }"
            class="alert-card mb-4"
          >
            <div class="alert-stripe warning-stripe"></div>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" md="8">
                  <div class="alert-content">
                    <div class="alert-header">
                      <v-icon size="32" color="#FF9800" class="mr-3"
                        >mdi-briefcase</v-icon
                      >
                      <div>
                        <h2 class="alert-title">
                          พนักงานราชการ - รายงานการสำรวจตำแหน่งว่าง
                        </h2>
                        <p class="alert-description">
                          ให้วิทยาลัยดำเนินการรายงานการสำรวจตำแหน่งว่างพนักงานราชการก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="alert-deadline">
                      <v-icon color="error" class="mr-2"
                        >mdi-calendar-clock</v-icon
                      >
                      <span class="deadline-text"
                        >ปิดระบบ:
                        {{
                          formatDeadline(
                            period_teacher_govem_manpower.period_college_stop
                          )
                        }}</span
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="alert-actions">
                    <flip-countdown
                      :deadline="
                        period_teacher_govem_manpower.period_college_stop +
                          ' 16:30:00'
                      "
                      :labels="labels"
                      class="countdown-timer"
                    ></flip-countdown>
                    <v-btn
                      color="warning"
                      large
                      to="/iven/conditions_branch_govem"
                      class="action-btn"
                      elevation="4"
                    >
                      <v-icon class="mr-2">mdi-arrow-right</v-icon>
                      ดำเนินการ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>

        <!-- พนักงานราชการ - รวบรวมคำร้องขอย้ายพนักงานราชการ -->
        <v-hover
          v-slot="{ hover }"
          v-if="period_teacher_govem_file.period_college_enable === '1'"
        >
          <v-card
            :elevation="hover ? 24 : 8"
            :class="{ 'on-hover': hover }"
            class="alert-card mb-4"
          >
            <div class="alert-stripe warning-stripe"></div>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" md="8">
                  <div class="alert-content">
                    <div class="alert-header">
                      <v-icon size="32" color="#FF9800" class="mr-3"
                        >mdi-briefcase</v-icon
                      >
                      <div>
                        <h2 class="alert-title">
                          พนักงานราชการ - รวบรวมคำร้องขอย้าย
                          ตำแหน่งพนักงานราชการ
                        </h2>
                        <p class="alert-description">
                          ให้วิทยาลัยดำเนินการรวบรวมคำร้องขอย้าย
                          ตำแหน่งพนักงานราชการ ก่อนระบบปิด
                        </p>
                      </div>
                    </div>
                    <div class="alert-deadline">
                      <v-icon color="error" class="mr-2"
                        >mdi-calendar-clock</v-icon
                      >
                      <span class="deadline-text"
                        >ปิดระบบ:
                        {{
                          formatDeadline(
                            period_teacher_govem_file.period_college_stop
                          )
                        }}</span
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="alert-actions">
                    <flip-countdown
                      :deadline="
                        period_teacher_govem_file.period_college_stop +
                          ' 16:30:00'
                      "
                      :labels="labels"
                      class="countdown-timer"
                    ></flip-countdown>
                    <v-btn
                      color="warning"
                      large
                      to="/iven/transference_personnel_govem"
                      class="action-btn"
                      elevation="4"
                    >
                      <v-icon class="mr-2">mdi-arrow-right</v-icon>
                      ดำเนินการ
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>

        <!--สถาบันการอาชีวศึกษา สมัครผู้อำนวยการวิทยาลัย -->
        <v-hover v-slot="{ hover }">
          <v-card
            :elevation="hover ? 16 : 2"
            :class="{ 'on-hover': hover }"
            class="pa-2"
            v-if="assessment_directiors.period_vecprovince_enable === '1'"
          >
            <v-row cols="12" md="7">
              <v-col>
                <v-alert
                  outlined
                  prominent
                  icon="mdi-bell-ring"
                  type="error"
                  border="left"
                >
                  <h2 class="secondary--text">
                    <v-icon color="secondary">mdi-domain</v-icon>
                    สถาบันการอาชีวศึกษา
                  </h2>

                  <h3>
                    ดำเนินการ <u> ประเมิน ภาค ข ส่วนที่ 1 ผู้สมัครคัดเลือก</u>
                    <br />
                    <u>ตำแหน่ง ผู้อำนวยการวิทยาลัย </u>
                    <br />
                    ครั้งที่
                    {{ assessment_directiors.period_vecprovince_times }} /
                    {{ assessment_directiors.period_vecprovince_year }}

                    ก่อนระบบปิดในวันที่
                    {{
                      assessment_directiors.period_vecprovince_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </h3>
                  <v-btn color="info" to="/iven/director_app_b">
                    <v-icon class="pr-2">mdi-account-convert</v-icon>
                    ผู้สมัคร</v-btn
                  >
                </v-alert>
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-center">
                  <h3>
                    ปิดระบบ ตรวจสอบเอกสาร ผู้สมัครสอบ : <br />
                    {{
                      assessment_directiors.period_vecprovince_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                    <br />
                    เหลือเวลาอีก
                  </h3>
                  <flip-countdown
                    :deadline="
                      assessment_directiors.period_vecprovince_stop +
                        ' 24:00:00'
                    "
                    :labels="labels"
                  ></flip-countdown>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="12">
        <PersonnelIvenCount />
      </v-col>
      <v-col cols="12" md="12">
        <studentStd />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alert_salary_gov from "../../components/gov_salary/alert_salary_gov.vue";
import PersonnelIvenCount from "../../components/iven/personnelIvenCount.vue";
import studentStd from "../../components/iven/studentStd.vue";
import FlipCountdown from "vue2-flip-countdown";
export default {
  name: "DashboardDashboard",
  data() {
    return {
      ApiKey: "HRvec2021",
      assessment_directiors: [],
      stop: {
        type: Boolean
      },
      showDays: {
        type: Boolean,
        required: false,
        default: true
      },
      showHours: {
        type: Boolean,
        required: false,
        default: true
      },
      showMinutes: {
        type: Boolean,
        required: false,
        default: true
      },
      showSeconds: {
        type: Boolean,
        required: false,
        default: true
      },

      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      countdownSize: {
        type: String,
        required: false
      },
      labelSize: {
        type: String,
        required: false
      },

      period_teacher_govem_manpower: {},
      period_teacher_govem_file: {}
    };
  },
  async mounted() {
    await this.period_directorAssQuery();
    await this.period_collegeGovem();
    await this.period_teacher_govem_fileQuery();
  },
  methods: {
    formatDeadline(dateString) {
      if (!dateString) return "";
      // Add 543 years for Buddhist calendar and format
      const date = new Date(dateString);
      date.setFullYear(date.getFullYear());
      return date.toLocaleDateString("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric"
      });
    },

    async period_collegeGovem() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "801"
          }
        );
        this.period_teacher_govem_manpower = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_manpower = {};
      }
    },

    async period_teacher_govem_fileQuery() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "80101"
          }
        );
        this.period_teacher_govem_file = result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_file = {};
      }
    },

    async period_directorAssQuery() {
      let result_period;
      result_period = await this.$http.post("period_vecprovince.php", {
        ApiKey: this.ApiKey,
        period_vecprovinc_id: "40102"
      });
      this.assessment_directiors = result_period.data;
    }
  },
  components: {
    FlipCountdown,
    PersonnelIvenCount,
    studentStd,
    Alert_salary_gov
  }
};
</script>
